
                import Handlebars from 'handlebars/dist/handlebars.runtime';
                const templateFunction = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"library\">\n    <h3 class=\"library-title\">Oops...</h3>\n    <p class=\"library-text\">No movies have been added yet. Let's go pick something to your liking</p>\n    <a class=\"library-button\" href=\"\">go to Home</a>\n</div>";
},"useData":true});
                export default templateFunction;
                